export const messages = {
  header: 'Add Payment Method',
  addCard: 'Add Card',
  payInCar: 'Pay In Car',
  addInvoice: 'Invoice Me Monthly',
  next: 'Next',
};
